export default { logMessage: 'b2dfad1' };
